module.exports = __webpack_public_path__ + "static/media/MW.dcb391a7.png";